<script setup lang="ts">
import HeaderLayout from "./headerLayout.vue";
import FooterLayout from "./footerLayout.vue";
import { useRoute } from "vue-router";
import Contact from "./component/contact.vue";
const route = useRoute();
</script>
<template>
  <HeaderLayout></HeaderLayout>
  <div class="main_container">
    <Contact></Contact>
    <RouterView :key="route.fullPath"></RouterView>
  </div>
  <FooterLayout></FooterLayout>
</template>
